import { DeltaStatic } from 'quill'
import { IntlShape } from 'react-intl'
import { Base64ImageUrl, NewCreatedCourse } from '../Course/types'

export const extractAnswersFromChecklist = (content: string) => {
  const parsedContent: DeltaStatic | null = JSON.parse(content)

  if (!parsedContent || !parsedContent.ops) {
    return []
  }

  const answers: Array<boolean> = []
    
  parsedContent.ops.forEach((item) => {
    if (item.attributes && item.attributes.list === 'checked') {
      answers.push(true)
    }
  
    if (item.attributes && item.attributes.list === 'unchecked') {
      answers.push(false)
    }
  })

  return answers
}

export const newlines = (n: number) => '\n'.repeat(n)

/**
 * 
 * @param intl needs intl to be able to translate the default course name and description
 * @returns an empty course that the Editor can read
 */
export const createDefaultCourse = (intl: IntlShape, userId: number): NewCreatedCourse => ({ 
  name: intl.formatMessage({ id: 'course.newCourse' }),
  userId,
  description: intl.formatMessage({ id: 'course.description' }),
  pages: [
    {
      pageNumber: 1,
      content: {
        ops: [
          {
            insert: `${newlines(10)}`
          }
        ]
      },
      previewPicture: '',
      previewPictureIsFromPdf: false
    }
  ],
  hasUnsavedChanges: false,
  isPublished: false,
  questions: [],
  examValidityMonths: 12,
})

export const createDefaultCourseFromPdfImages = (
  images: Array<Base64ImageUrl>,
  intl: IntlShape,
  userId: number
): NewCreatedCourse => ({ 
  name: intl.formatMessage({ id: 'course.newCourse' }),
  userId,
  description: intl.formatMessage({ id: 'course.description' }),
  pages: images.map((image, index) => {
    return {
      pageNumber: index + 1,
      content: {
        ops: [
          {
            insert: `${newlines(10)}`
          }
        ]
      },
      previewPicture: image,
      previewPictureIsFromPdf: true
    }
  }),
  fromPdf: true,
  importedPdfPages: images.length,
  hasUnsavedChanges: true,
  isPublished: false,
  questions: [],
  examValidityMonths: 12,
})